/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Error_Load_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to load authorization details" |
*
* @param {Oauth_Error_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_error_load_failed = /** @type {((inputs?: Oauth_Error_Load_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Error_Load_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du chargement des détails d'autorisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al cargar detalles de autorización")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao carregar detalhes de autorização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare i dettagli di autorizzazione")
	return /** @type {LocalizedString} */ ("Failed to load authorization details")
});